/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type CreateClientAsAdmin201Response,
    CreateClientAsAdmin201ResponseFromJSON,
    CreateClientAsAdmin201ResponseToJSON,
} from '../models/CreateClientAsAdmin201Response';
import {
    type CreateClientAsAdminRequest,
    CreateClientAsAdminRequestFromJSON,
    CreateClientAsAdminRequestToJSON,
} from '../models/CreateClientAsAdminRequest';
import {
    type CreateResellerApiAccount201Response,
    CreateResellerApiAccount201ResponseFromJSON,
    CreateResellerApiAccount201ResponseToJSON,
} from '../models/CreateResellerApiAccount201Response';
import {
    type CreateResellerInvoiceOverviews200Response,
    CreateResellerInvoiceOverviews200ResponseFromJSON,
    CreateResellerInvoiceOverviews200ResponseToJSON,
} from '../models/CreateResellerInvoiceOverviews200Response';
import {
    type CreateResellerRequest,
    CreateResellerRequestFromJSON,
    CreateResellerRequestToJSON,
} from '../models/CreateResellerRequest';
import {
    type CreateSupportRequest400Response,
    CreateSupportRequest400ResponseFromJSON,
    CreateSupportRequest400ResponseToJSON,
} from '../models/CreateSupportRequest400Response';
import {
    type CreateUsageBasedInvoices200Response,
    CreateUsageBasedInvoices200ResponseFromJSON,
    CreateUsageBasedInvoices200ResponseToJSON,
} from '../models/CreateUsageBasedInvoices200Response';
import {
    type DeleteReseller200Response,
    DeleteReseller200ResponseFromJSON,
    DeleteReseller200ResponseToJSON,
} from '../models/DeleteReseller200Response';
import {
    type ExecuteGraphRequest200Response,
    ExecuteGraphRequest200ResponseFromJSON,
    ExecuteGraphRequest200ResponseToJSON,
} from '../models/ExecuteGraphRequest200Response';
import {
    type ExecuteGraphRequestRequest,
    ExecuteGraphRequestRequestFromJSON,
    ExecuteGraphRequestRequestToJSON,
} from '../models/ExecuteGraphRequestRequest';
import {
    type FinalizeUsageBasedInvoices200Response,
    FinalizeUsageBasedInvoices200ResponseFromJSON,
    FinalizeUsageBasedInvoices200ResponseToJSON,
} from '../models/FinalizeUsageBasedInvoices200Response';
import {
    type GetAllServiceProviders200Response,
    GetAllServiceProviders200ResponseFromJSON,
    GetAllServiceProviders200ResponseToJSON,
} from '../models/GetAllServiceProviders200Response';
import {
    type GetEmailQueueCount200Response,
    GetEmailQueueCount200ResponseFromJSON,
    GetEmailQueueCount200ResponseToJSON,
} from '../models/GetEmailQueueCount200Response';
import {
    type GetEntraSyncFailures200Response,
    GetEntraSyncFailures200ResponseFromJSON,
    GetEntraSyncFailures200ResponseToJSON,
} from '../models/GetEntraSyncFailures200Response';
import {
    type GetIoePreviewFindings200Response,
    GetIoePreviewFindings200ResponseFromJSON,
    GetIoePreviewFindings200ResponseToJSON,
} from '../models/GetIoePreviewFindings200Response';
import {
    type GetResellerInfo200Response,
    GetResellerInfo200ResponseFromJSON,
    GetResellerInfo200ResponseToJSON,
} from '../models/GetResellerInfo200Response';
import {
    type GetResellerServiceprovidersAsAdmin200ResponseInner,
    GetResellerServiceprovidersAsAdmin200ResponseInnerFromJSON,
    GetResellerServiceprovidersAsAdmin200ResponseInnerToJSON,
} from '../models/GetResellerServiceprovidersAsAdmin200ResponseInner';
import {
    type GetWellKnownEmailServices401Response,
    GetWellKnownEmailServices401ResponseFromJSON,
    GetWellKnownEmailServices401ResponseToJSON,
} from '../models/GetWellKnownEmailServices401Response';
import {
    type GetWellKnownEmailServices500Response,
    GetWellKnownEmailServices500ResponseFromJSON,
    GetWellKnownEmailServices500ResponseToJSON,
} from '../models/GetWellKnownEmailServices500Response';
import {
    type ListResellers200ResponseInner,
    ListResellers200ResponseInnerFromJSON,
    ListResellers200ResponseInnerToJSON,
} from '../models/ListResellers200ResponseInner';
import {
    type RecreateHasuraSchema200Response,
    RecreateHasuraSchema200ResponseFromJSON,
    RecreateHasuraSchema200ResponseToJSON,
} from '../models/RecreateHasuraSchema200Response';
import {
    type SetMailingStatusRequest,
    SetMailingStatusRequestFromJSON,
    SetMailingStatusRequestToJSON,
} from '../models/SetMailingStatusRequest';
import {
    type UpdateResellerRequest,
    UpdateResellerRequestFromJSON,
    UpdateResellerRequestToJSON,
} from '../models/UpdateResellerRequest';

export interface CreateClientAsAdminOperationRequest {
    /**
     * 
     */
    createClientAsAdminRequest: CreateClientAsAdminRequest;
}

export interface CreateResellerOperationRequest {
    /**
     * 
     */
    createResellerRequest: CreateResellerRequest;
}

export interface CreateResellerApiAccountRequest {
    /**
     * UUID of the reseller.
     */
    resellerUUID: string;
}

export interface DeleteResellerRequest {
    /**
     * UUID of the reseller.
     */
    resellerUUID: string;
}

export interface DeleteResellerApiAccountRequest {
    /**
     * UUID of the reseller.
     */
    resellerUUID: string;
}

export interface DeleteSubscriptionRequest {
    /**
     * 
     */
    clientUUID: string;
}

export interface ExecuteGraphRequestOperationRequest {
    /**
     * 
     */
    executeGraphRequestRequest: ExecuteGraphRequestRequest;
}

export interface ExportSelfhostedDataCSVRequest {
    /**
     * Month in YYYY-MM format
     */
    month: string;
    /**
     * Selfhosted instance UUID
     */
    instanceId: string;
}

export interface GetIoePreviewFindingsRequest {
    /**
     * Only findings of this IoE
     */
    ioeId?: string;
}

export interface GetResellerInfoRequest {
    /**
     * 
     */
    resellerUUID: string;
}

export interface GetResellerServiceprovidersAsAdminRequest {
    /**
     * UUID of the reseller.
     */
    resellerUUID: string;
}

export interface RecreateCollectorConfigRequest {
    /**
     * 
     */
    clientUUID: string;
}

export interface RotateResellerApiAccountSecretRequest {
    /**
     * UUID of the reseller.
     */
    resellerUUID: string;
}

export interface SetMailingStatusOperationRequest {
    /**
     * 
     */
    setMailingStatusRequest: SetMailingStatusRequest;
}

export interface UpdateResellerOperationRequest {
    /**
     * UUID of the reseller.
     */
    resellerUUID: string;
    /**
     * 
     */
    updateResellerRequest: UpdateResellerRequest;
}

/**
 * 
 */
export class AdminApi extends runtime.BaseAPI {

    /**
     * Creates request options for createClientAsAdmin without sending the request
     */
    async createClientAsAdminRequestOpts(requestParameters: CreateClientAsAdminOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createClientAsAdminRequest'] == null) {
            throw new runtime.RequiredError(
                'createClientAsAdminRequest',
                'Required parameter "createClientAsAdminRequest" was null or undefined when calling createClientAsAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/client/new`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClientAsAdminRequestToJSON(requestParameters['createClientAsAdminRequest']),
        };
    }

    /**
     * Create a new client
     */
    async createClientAsAdminRaw(requestParameters: CreateClientAsAdminOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateClientAsAdmin201Response>> {
        const requestOptions = await this.createClientAsAdminRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateClientAsAdmin201ResponseFromJSON(jsonValue));
    }

    /**
     * Create a new client
     */
    async createClientAsAdmin(createClientAsAdminRequest: CreateClientAsAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateClientAsAdmin201Response> {
        const response = await this.createClientAsAdminRaw({ createClientAsAdminRequest: createClientAsAdminRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createReseller without sending the request
     */
    async createResellerRequestOpts(requestParameters: CreateResellerOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['createResellerRequest'] == null) {
            throw new runtime.RequiredError(
                'createResellerRequest',
                'Required parameter "createResellerRequest" was null or undefined when calling createReseller().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/reseller`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateResellerRequestToJSON(requestParameters['createResellerRequest']),
        };
    }

    /**
     * Create reseller
     */
    async createResellerRaw(requestParameters: CreateResellerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListResellers200ResponseInner>> {
        const requestOptions = await this.createResellerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListResellers200ResponseInnerFromJSON(jsonValue));
    }

    /**
     * Create reseller
     */
    async createReseller(createResellerRequest: CreateResellerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListResellers200ResponseInner> {
        const response = await this.createResellerRaw({ createResellerRequest: createResellerRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createResellerApiAccount without sending the request
     */
    async createResellerApiAccountRequestOpts(requestParameters: CreateResellerApiAccountRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['resellerUUID'] == null) {
            throw new runtime.RequiredError(
                'resellerUUID',
                'Required parameter "resellerUUID" was null or undefined when calling createResellerApiAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/reseller/{resellerUUID}/api-account`;
        urlPath = urlPath.replace('{resellerUUID}', encodeURIComponent(String(requestParameters['resellerUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Creates the reseller\'s API account - a dedicated Keycloak client that authenticates via client credentials grant and acts as the reseller on the reseller API.  **Important:** The client secret is returned only once.
     * Create reseller API account
     */
    async createResellerApiAccountRaw(requestParameters: CreateResellerApiAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateResellerApiAccount201Response>> {
        const requestOptions = await this.createResellerApiAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateResellerApiAccount201ResponseFromJSON(jsonValue));
    }

    /**
     * Creates the reseller\'s API account - a dedicated Keycloak client that authenticates via client credentials grant and acts as the reseller on the reseller API.  **Important:** The client secret is returned only once.
     * Create reseller API account
     */
    async createResellerApiAccount(resellerUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateResellerApiAccount201Response> {
        const response = await this.createResellerApiAccountRaw({ resellerUUID: resellerUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createResellerInvoiceOverviews without sending the request
     */
    async createResellerInvoiceOverviewsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/invoices/reseller`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Generates CSV invoice overviews for all invoiced resellers and emails them to the admin
     */
    async createResellerInvoiceOverviewsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateResellerInvoiceOverviews200Response>> {
        const requestOptions = await this.createResellerInvoiceOverviewsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateResellerInvoiceOverviews200ResponseFromJSON(jsonValue));
    }

    /**
     * Generates CSV invoice overviews for all invoiced resellers and emails them to the admin
     */
    async createResellerInvoiceOverviews(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateResellerInvoiceOverviews200Response> {
        const response = await this.createResellerInvoiceOverviewsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createUsageBasedInvoices without sending the request
     */
    async createUsageBasedInvoicesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/invoices/usage`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Creates usage-based draft invoices for all service providers
     */
    async createUsageBasedInvoicesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateUsageBasedInvoices200Response>> {
        const requestOptions = await this.createUsageBasedInvoicesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateUsageBasedInvoices200ResponseFromJSON(jsonValue));
    }

    /**
     * Creates usage-based draft invoices for all service providers
     */
    async createUsageBasedInvoices(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateUsageBasedInvoices200Response> {
        const response = await this.createUsageBasedInvoicesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteReseller without sending the request
     */
    async deleteResellerRequestOpts(requestParameters: DeleteResellerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['resellerUUID'] == null) {
            throw new runtime.RequiredError(
                'resellerUUID',
                'Required parameter "resellerUUID" was null or undefined when calling deleteReseller().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/reseller/{resellerUUID}`;
        urlPath = urlPath.replace('{resellerUUID}', encodeURIComponent(String(requestParameters['resellerUUID'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Deletes a reseller including its Keycloak accounts (personal logins and API client). Fails with 409 while serviceproviders are still assigned.
     * Delete reseller
     */
    async deleteResellerRaw(requestParameters: DeleteResellerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.deleteResellerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Deletes a reseller including its Keycloak accounts (personal logins and API client). Fails with 409 while serviceproviders are still assigned.
     * Delete reseller
     */
    async deleteReseller(resellerUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.deleteResellerRaw({ resellerUUID: resellerUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteResellerApiAccount without sending the request
     */
    async deleteResellerApiAccountRequestOpts(requestParameters: DeleteResellerApiAccountRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['resellerUUID'] == null) {
            throw new runtime.RequiredError(
                'resellerUUID',
                'Required parameter "resellerUUID" was null or undefined when calling deleteResellerApiAccount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/reseller/{resellerUUID}/api-account`;
        urlPath = urlPath.replace('{resellerUUID}', encodeURIComponent(String(requestParameters['resellerUUID'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete reseller API account
     */
    async deleteResellerApiAccountRaw(requestParameters: DeleteResellerApiAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.deleteResellerApiAccountRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete reseller API account
     */
    async deleteResellerApiAccount(resellerUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.deleteResellerApiAccountRaw({ resellerUUID: resellerUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteSubscription without sending the request
     */
    async deleteSubscriptionRequestOpts(requestParameters: DeleteSubscriptionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling deleteSubscription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/client/{clientUUID}`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * delete client
     */
    async deleteSubscriptionRaw(requestParameters: DeleteSubscriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.deleteSubscriptionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * delete client
     */
    async deleteSubscription(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.deleteSubscriptionRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for executeGraphRequest without sending the request
     */
    async executeGraphRequestRequestOpts(requestParameters: ExecuteGraphRequestOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['executeGraphRequestRequest'] == null) {
            throw new runtime.RequiredError(
                'executeGraphRequestRequest',
                'Required parameter "executeGraphRequestRequest" was null or undefined when calling executeGraphRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/graph-explorer/request`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExecuteGraphRequestRequestToJSON(requestParameters['executeGraphRequestRequest']),
        };
    }

    /**
     * Execute a graph request
     */
    async executeGraphRequestRaw(requestParameters: ExecuteGraphRequestOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExecuteGraphRequest200Response>> {
        const requestOptions = await this.executeGraphRequestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExecuteGraphRequest200ResponseFromJSON(jsonValue));
    }

    /**
     * Execute a graph request
     */
    async executeGraphRequest(executeGraphRequestRequest: ExecuteGraphRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExecuteGraphRequest200Response> {
        const response = await this.executeGraphRequestRaw({ executeGraphRequestRequest: executeGraphRequestRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for exportSelfhostedDataCSV without sending the request
     */
    async exportSelfhostedDataCSVRequestOpts(requestParameters: ExportSelfhostedDataCSVRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['month'] == null) {
            throw new runtime.RequiredError(
                'month',
                'Required parameter "month" was null or undefined when calling exportSelfhostedDataCSV().'
            );
        }

        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling exportSelfhostedDataCSV().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['month'] != null) {
            queryParameters['month'] = requestParameters['month'];
        }

        if (requestParameters['instanceId'] != null) {
            queryParameters['instanceId'] = requestParameters['instanceId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/selfhosted/export-csv`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Export all heartbeats for a specific selfhosted instance and month as CSV
     */
    async exportSelfhostedDataCSVRaw(requestParameters: ExportSelfhostedDataCSVRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.exportSelfhostedDataCSVRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Export all heartbeats for a specific selfhosted instance and month as CSV
     */
    async exportSelfhostedDataCSV(month: string, instanceId: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.exportSelfhostedDataCSVRaw({ month: month, instanceId: instanceId }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for finalizeUsageBasedInvoices without sending the request
     */
    async finalizeUsageBasedInvoicesRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/invoices/usage/finalize`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Finalizes draft usage-based invoices and emails PDFs with CSV summaries to service providers
     */
    async finalizeUsageBasedInvoicesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FinalizeUsageBasedInvoices200Response>> {
        const requestOptions = await this.finalizeUsageBasedInvoicesRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FinalizeUsageBasedInvoices200ResponseFromJSON(jsonValue));
    }

    /**
     * Finalizes draft usage-based invoices and emails PDFs with CSV summaries to service providers
     */
    async finalizeUsageBasedInvoices(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FinalizeUsageBasedInvoices200Response> {
        const response = await this.finalizeUsageBasedInvoicesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getAllServiceProviders without sending the request
     */
    async getAllServiceProvidersRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/serviceprovider`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all service providers with their clients grouped by type
     */
    async getAllServiceProvidersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAllServiceProviders200Response>> {
        const requestOptions = await this.getAllServiceProvidersRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAllServiceProviders200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all service providers with their clients grouped by type
     */
    async getAllServiceProviders(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAllServiceProviders200Response> {
        const response = await this.getAllServiceProvidersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getEmailQueueCount without sending the request
     */
    async getEmailQueueCountRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/email/queue-count`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the number of emails waiting in the queue
     */
    async getEmailQueueCountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEmailQueueCount200Response>> {
        const requestOptions = await this.getEmailQueueCountRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEmailQueueCount200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the number of emails waiting in the queue
     */
    async getEmailQueueCount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEmailQueueCount200Response> {
        const response = await this.getEmailQueueCountRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getEntraSyncFailures without sending the request
     */
    async getEntraSyncFailuresRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/entra-sync/failures`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all clients whose Entra ID sync has failed repeatedly, including retry count and last error reason
     */
    async getEntraSyncFailuresRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEntraSyncFailures200Response>> {
        const requestOptions = await this.getEntraSyncFailuresRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEntraSyncFailures200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all clients whose Entra ID sync has failed repeatedly, including retry count and last error reason
     */
    async getEntraSyncFailures(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEntraSyncFailures200Response> {
        const response = await this.getEntraSyncFailuresRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getIoePreviewFindings without sending the request
     */
    async getIoePreviewFindingsRequestOpts(requestParameters: GetIoePreviewFindingsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['ioeId'] != null) {
            queryParameters['ioeId'] = requestParameters['ioeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/ioe-preview-findings`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the findings of all unpublished IoEs across all clients (latest scan per client and IoE), including client and serviceprovider
     */
    async getIoePreviewFindingsRaw(requestParameters: GetIoePreviewFindingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetIoePreviewFindings200Response>> {
        const requestOptions = await this.getIoePreviewFindingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetIoePreviewFindings200ResponseFromJSON(jsonValue));
    }

    /**
     * Get the findings of all unpublished IoEs across all clients (latest scan per client and IoE), including client and serviceprovider
     */
    async getIoePreviewFindings(ioeId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetIoePreviewFindings200Response> {
        const response = await this.getIoePreviewFindingsRaw({ ioeId: ioeId }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getResellerInfo without sending the request
     */
    async getResellerInfoRequestOpts(requestParameters: GetResellerInfoRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['resellerUUID'] == null) {
            throw new runtime.RequiredError(
                'resellerUUID',
                'Required parameter "resellerUUID" was null or undefined when calling getResellerInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/reseller/{resellerUUID}`;
        urlPath = urlPath.replace('{resellerUUID}', encodeURIComponent(String(requestParameters['resellerUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get reseller information by UUID
     */
    async getResellerInfoRaw(requestParameters: GetResellerInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetResellerInfo200Response>> {
        const requestOptions = await this.getResellerInfoRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetResellerInfo200ResponseFromJSON(jsonValue));
    }

    /**
     * Get reseller information by UUID
     */
    async getResellerInfo(resellerUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetResellerInfo200Response> {
        const response = await this.getResellerInfoRaw({ resellerUUID: resellerUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getResellerServiceprovidersAsAdmin without sending the request
     */
    async getResellerServiceprovidersAsAdminRequestOpts(requestParameters: GetResellerServiceprovidersAsAdminRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['resellerUUID'] == null) {
            throw new runtime.RequiredError(
                'resellerUUID',
                'Required parameter "resellerUUID" was null or undefined when calling getResellerServiceprovidersAsAdmin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/reseller/{resellerUUID}/serviceprovider`;
        urlPath = urlPath.replace('{resellerUUID}', encodeURIComponent(String(requestParameters['resellerUUID'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List serviceproviders of a reseller
     */
    async getResellerServiceprovidersAsAdminRaw(requestParameters: GetResellerServiceprovidersAsAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetResellerServiceprovidersAsAdmin200ResponseInner>>> {
        const requestOptions = await this.getResellerServiceprovidersAsAdminRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetResellerServiceprovidersAsAdmin200ResponseInnerFromJSON));
    }

    /**
     * List serviceproviders of a reseller
     */
    async getResellerServiceprovidersAsAdmin(resellerUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetResellerServiceprovidersAsAdmin200ResponseInner>> {
        const response = await this.getResellerServiceprovidersAsAdminRaw({ resellerUUID: resellerUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listResellers without sending the request
     */
    async listResellersRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/reseller`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns all resellers with their settings, number of serviceproviders and API account.
     * List resellers
     */
    async listResellersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ListResellers200ResponseInner>>> {
        const requestOptions = await this.listResellersRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ListResellers200ResponseInnerFromJSON));
    }

    /**
     * Returns all resellers with their settings, number of serviceproviders and API account.
     * List resellers
     */
    async listResellers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ListResellers200ResponseInner>> {
        const response = await this.listResellersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for recreateCollectorConfig without sending the request
     */
    async recreateCollectorConfigRequestOpts(requestParameters: RecreateCollectorConfigRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['clientUUID'] == null) {
            throw new runtime.RequiredError(
                'clientUUID',
                'Required parameter "clientUUID" was null or undefined when calling recreateCollectorConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuthCollector authentication
        }


        let urlPath = `/client/{clientUUID}/collector/config/recreate`;
        urlPath = urlPath.replace('{clientUUID}', encodeURIComponent(String(requestParameters['clientUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Recreate collector config including new password and license jwt
     */
    async recreateCollectorConfigRaw(requestParameters: RecreateCollectorConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.recreateCollectorConfigRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Recreate collector config including new password and license jwt
     */
    async recreateCollectorConfig(clientUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.recreateCollectorConfigRaw({ clientUUID: clientUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for recreateHasuraSchema without sending the request
     */
    async recreateHasuraSchemaRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/hasura/recreate-schema`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Recreate Hasura schema for all instances
     */
    async recreateHasuraSchemaRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RecreateHasuraSchema200Response>> {
        const requestOptions = await this.recreateHasuraSchemaRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RecreateHasuraSchema200ResponseFromJSON(jsonValue));
    }

    /**
     * Recreate Hasura schema for all instances
     */
    async recreateHasuraSchema(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RecreateHasuraSchema200Response> {
        const response = await this.recreateHasuraSchemaRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for rotateResellerApiAccountSecret without sending the request
     */
    async rotateResellerApiAccountSecretRequestOpts(requestParameters: RotateResellerApiAccountSecretRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['resellerUUID'] == null) {
            throw new runtime.RequiredError(
                'resellerUUID',
                'Required parameter "resellerUUID" was null or undefined when calling rotateResellerApiAccountSecret().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/reseller/{resellerUUID}/api-account/rotate`;
        urlPath = urlPath.replace('{resellerUUID}', encodeURIComponent(String(requestParameters['resellerUUID'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Generates a new client secret; the old one stops working immediately. Access tokens already issued stay valid until they expire.  **Important:** The new secret is returned only once.
     * Rotate reseller API account secret
     */
    async rotateResellerApiAccountSecretRaw(requestParameters: RotateResellerApiAccountSecretRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateResellerApiAccount201Response>> {
        const requestOptions = await this.rotateResellerApiAccountSecretRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateResellerApiAccount201ResponseFromJSON(jsonValue));
    }

    /**
     * Generates a new client secret; the old one stops working immediately. Access tokens already issued stay valid until they expire.  **Important:** The new secret is returned only once.
     * Rotate reseller API account secret
     */
    async rotateResellerApiAccountSecret(resellerUUID: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateResellerApiAccount201Response> {
        const response = await this.rotateResellerApiAccountSecretRaw({ resellerUUID: resellerUUID }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for sendTestEmail without sending the request
     */
    async sendTestEmailRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/email/test`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Send a test email to the authenticated user\'s email address
     */
    async sendTestEmailRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.sendTestEmailRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Send a test email to the authenticated user\'s email address
     */
    async sendTestEmail(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.sendTestEmailRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setMailingStatus without sending the request
     */
    async setMailingStatusRequestOpts(requestParameters: SetMailingStatusOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['setMailingStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'setMailingStatusRequest',
                'Required parameter "setMailingStatusRequest" was null or undefined when calling setMailingStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/email/status`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetMailingStatusRequestToJSON(requestParameters['setMailingStatusRequest']),
        };
    }

    /**
     * Set mailing status (enabled/disabled)
     */
    async setMailingStatusRaw(requestParameters: SetMailingStatusOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteReseller200Response>> {
        const requestOptions = await this.setMailingStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteReseller200ResponseFromJSON(jsonValue));
    }

    /**
     * Set mailing status (enabled/disabled)
     */
    async setMailingStatus(setMailingStatusRequest: SetMailingStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteReseller200Response> {
        const response = await this.setMailingStatusRaw({ setMailingStatusRequest: setMailingStatusRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateReseller without sending the request
     */
    async updateResellerRequestOpts(requestParameters: UpdateResellerOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['resellerUUID'] == null) {
            throw new runtime.RequiredError(
                'resellerUUID',
                'Required parameter "resellerUUID" was null or undefined when calling updateReseller().'
            );
        }

        if (requestParameters['updateResellerRequest'] == null) {
            throw new runtime.RequiredError(
                'updateResellerRequest',
                'Required parameter "updateResellerRequest" was null or undefined when calling updateReseller().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/admin/reseller/{resellerUUID}`;
        urlPath = urlPath.replace('{resellerUUID}', encodeURIComponent(String(requestParameters['resellerUUID'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateResellerRequestToJSON(requestParameters['updateResellerRequest']),
        };
    }

    /**
     * Updates the given settings. `invoiced` and `spNewPricing` are only applied to serviceproviders the reseller creates afterwards.
     * Update reseller settings
     */
    async updateResellerRaw(requestParameters: UpdateResellerOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListResellers200ResponseInner>> {
        const requestOptions = await this.updateResellerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListResellers200ResponseInnerFromJSON(jsonValue));
    }

    /**
     * Updates the given settings. `invoiced` and `spNewPricing` are only applied to serviceproviders the reseller creates afterwards.
     * Update reseller settings
     */
    async updateReseller(resellerUUID: string, updateResellerRequest: UpdateResellerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListResellers200ResponseInner> {
        const response = await this.updateResellerRaw({ resellerUUID: resellerUUID, updateResellerRequest: updateResellerRequest }, initOverrides);
        return await response.value();
    }

}
